
import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "./avatar";
import { Button } from "./button";
import { X, Upload } from "lucide-react";

interface ImagePreviewProps {
  value: string | null | undefined;
  onRemove: () => void;
  size: "sm" | "md" | "lg";
  showRemove: boolean;
  disabled: boolean;
}

const sizeClasses = {
  sm: "h-16 w-16",
  md: "h-24 w-24",
  lg: "h-40 w-40", // Increased from h-32 w-32 to make the profile picture larger and clearer
};

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  value,
  onRemove,
  size = "md",
  showRemove = true,
  disabled = false,
}) => {
  if (!value) {
    return (
      <div
        className={`${sizeClasses[size]} rounded-full bg-muted flex items-center justify-center border-2 border-dashed border-gray-300`}
      >
        <Upload className="h-8 w-8 text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="relative">
      <Avatar className={`${sizeClasses[size]} border-2 border-muted shadow-md`}>
        <AvatarImage src={value} alt="Uploaded image" className="object-cover" />
        <AvatarFallback>...</AvatarFallback>
      </Avatar>
      {showRemove && (
        <Button
          type="button"
          variant="destructive"
          size="icon"
          className="absolute -top-2 -right-2 h-7 w-7 rounded-full"
          onClick={onRemove}
          disabled={disabled}
        >
          <X className="h-3 w-3" />
        </Button>
      )}
    </div>
  );
};
